import { capitalize } from 'lodash';
import { EMERGENT } from '../../constants';
import { RelatedType } from '../../types';
import {
  EXEMPLAR,
  SAVED_EXEMPLAR,
  SAVED_PROFORMA,
  TEXT_PRESENTATION,
  WORDS,
  WRITING_PROFORMA,
} from '../../constants/navigation';

export const getRedirectLink = (
  stage: string,
  textType: string,
  type: string,
  id?: number,
  isFullScreen?: boolean,
  page?: string
): string => {
  const screen = isFullScreen ? 'full-screen' : 'default';
  const defaultPage = stage.toLowerCase() === EMERGENT ? WORDS : TEXT_PRESENTATION;

  switch (type) {
    case RelatedType.exemplars:
      return `/${RelatedType.exemplars}/${stage.toLowerCase()}/${EXEMPLAR}/${id}/${screen}/${defaultPage}`;
    case RelatedType.saved_exemplars:
      return `/${RelatedType.exemplars}/${stage.toLowerCase()}/${SAVED_EXEMPLAR}/${id}/${screen}/${
        page || defaultPage
      }`;
    case RelatedType.saved_proformas:
      return `/${SAVED_PROFORMA}/${id}/${screen}/${WRITING_PROFORMA}?stage=${capitalize(stage)}`;
    case RelatedType.proformas:
      return `/${screen}/${WRITING_PROFORMA}?stage=${capitalize(stage)}&textType=${textType}`;
    default:
      return `/${RelatedType.exemplars}/${EMERGENT}/${EXEMPLAR}/${id}/${screen}/${WORDS}`;
  }
};
